import React, { useState, useContext, useEffect } from "react";
import dateFormat, { masks } from "dateformat";
// import { throttle } from "throttle-debounce";
import ic_blue_pen from "../../../assets/images/ic_blue_pen.svg";
import { Link } from "react-router-dom";
import { Form, Modal } from "react-bootstrap";
import { AppContext } from "../../../context/AppContext";
import DatePicker from "react-datepicker";
import calendersvg from "../../../assets/images/calender_19.svg";
import calendersvg_dark from "../../../assets/images/calender_19_dark.svg";
import "react-datepicker/dist/react-datepicker.css";
import {
  PostCallWithAuthToken,
  simpleGetCallWithToken,
} from "../../../api/ApiServices";
import ApiConfig from "../../../api/ApiConfig";
import { ToWords } from "to-words";
import {
  displayDateFormat,
  getDateddmmyyyy,
  roundedOff,
  ssingleProductHandler,
  toFixedValue,
} from "../../../common";
import BackDropLoader from "../../../sharedComponent/BackDropLoader";
import { productOnChangeHandler } from "../..";
import ProductTable from "../../../sharedComponent/ProductTable";
import Swal from "sweetalert2";
import { result } from "lodash";
import { ToastMsg } from "../../TostMsg";

let PurchaseServiceForm = ({
  CopiedData,
  newInvoice,
  handleInvoiceSearch,
  setInvoiceNo,
  reciveInvoiceId,
  getTaxInvoiceData,
  setIsView,
  setPrintButton,
  getInvoiceDetailsList,

  appSettings,
  invoiceEditData,
  invoiceAction,
  setInvoiceAction,
}) => {
  // Get Permissions from localStroge
  const userPermissions =
    localStorage.user && JSON.parse(localStorage.getItem("user"));
  const permissions = userPermissions?.permissions;
  var commaNumber = require("comma-number");
  const { Dark, setHideCopy, currentRoute, setSidebar, financialYearId } =
    useContext(AppContext);

  const [backDropOpen, setBackDropOpen] = useState(false);
  const [invGenerateState, setInvGenerateState] = useState(0);
  const [valueChanged, setValueChanged] = useState(false);
  const [products, setProducts] = useState([]);
  const toWords = new ToWords();
  const [hsnCodes, setHsnCodes] = useState([]);
  const [account, setAccount] = useState([]);
  let [addedNew, setAddedNew] = useState(false);
  const [validated, setValidated] = useState(false);
  const [nameList, setNameList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);

  const [invoiceFormDetails, setInvoiceFormDetails] = useState({
    financialYearId: financialYearId,
    invoiceNo: "",
    //financialYearId: 3,
    invoiceDate: new Date().toISOString().toString(),
    dueDate: new Date().toISOString().toString(),
    subTotal: 0,
    cgst: 0,
    cgstAmount: 0,
    sgst: 0,
    sgstAmount: 0,
    igst: 0,
    igstAmount: 0,
    suppName: "",
    suppAddr: "",
    suppState: "",
    suppCountry: "",
    suppEmail: "",
    suppContact: "",
    suppGstNo: "",
    suppPanNo: "",
    placeOfSupply: "",
    modeOfPay: "",
    chequeNo: "",
    bankName: "",
    compName: "",
    compAddr: "",
    compEmail: "",
    compContact: "",
    compGstNo: "",
    compPanNo: "",
    shipName: "",
    shipAddr: "",
    shipState: "",
    shipCountry: "",
    shipEmail: "",
    shipContact: "",
    shipGstNo: "",
    shipPanNo: "",
    grossAmount: 0,
    gstAmount: 0,
    totalAmount: 0,
    suppCity: "",
    suppPincode: "",
  });

  const amountInWords = toWords.convert(
    invoiceFormDetails.totalAmount ? invoiceFormDetails.totalAmount : 0,
    {
      currency: true,
    }
  );
  const [productDetails, setProductDetails] = useState([
    {
      hsnId: 0,
      gst: 0,
      gstAmount: 0,
      igst: 0,
      igstAmount: 0,
      sgst: 0,
      sgstAmount: 0,
      cgst: 0,
      cgstAmount: 0,
      discPer: 0,
      discAmount: 0,
      unitId: 15,
      productName: "",
      hsnCode: "",
      qty: 0,
      rate: 0,
    },
  ]);

  console.log("productDetails,", productDetails);

  let lengthOfPlaceOfSupply = invoiceFormDetails?.placeOfSupply.length;
  const isStateSame =
    invoiceFormDetails.compGstNo?.substring(0, 2) ===
    invoiceFormDetails.placeOfSupply.substring(
      lengthOfPlaceOfSupply - 2,
      lengthOfPlaceOfSupply
    );

  const [newProduct, setNewProduct] = useState({
    productCode: "",
    productName: "",
    rate: 0,
    ledgerAccId: 0,
    taxRate: "",
    hsnCode: "",
    hsnId: 0,
  });

  const [errMsg, setErrMsg] = useState({
    products: "",
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      addNewProductApiCall();
    }
    setValidated(true);
  };

  const getFocus = () => {
    if (invoiceFormDetails.invoiceNo.trim() === "") {
      document.getElementById("invoiceNo").focus();
      return;
    }
    if (invoiceFormDetails.placeOfSupply.trim() === "") {
      document.getElementById("placeOfSupply").focus();
      return;
    }
    if (invoiceFormDetails.modeOfPay.trim() === "") {
      document.getElementById("modeOfPay").focus();
      return;
    }
    if (
      invoiceFormDetails.chequeNo.trim() === "" &&
      invoiceFormDetails.modeOfPay === "Cheque"
    ) {
      document.getElementById("chequeNo").focus();
      return;
    }
    if (
      invoiceFormDetails.bankName.trim() === "" &&
      invoiceFormDetails.modeOfPay === "Cheque"
    ) {
      document.getElementById("bankName").focus();
      return;
    }
    if (invoiceFormDetails.suppName.trim() === "") {
      document.getElementById("suppName").focus();
      return;
    }
    if (invoiceFormDetails.suppAddr.trim() === "") {
      document.getElementById("suppAddr").focus();
      return;
    }
  };

  const savePurchaseForm = (event) => {
    event.preventDefault();

    const form = event?.currentTarget;
    if (form?.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      ToastMsg("error", "Please fill all required fields");
    } else if (
      productDetails[0].productName === "" &&
      productDetails[0].discAmount == 0
    ) {
      setErrMsg({ ...errMsg, products: "Please select product" });
      ToastMsg("error", "Please Fill Product Details");
    } else {
      Swal.fire({
        title: "Do you want to submit the invoice?",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Yes",
        denyButtonText: `Cancel`,
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          let filteredProductList = productDetails.filter((item, index) => {
            if (item.productName || item.hsnCode || item.cgst || item.sgst) {
              return item;
            }
          });
          var data = {
            ...invoiceFormDetails,
            purchInvDetails: filteredProductList,
          };
          PostCallWithAuthToken(ApiConfig.PURCHASESERVICE, JSON.stringify(data))
            .then((res) => {
              if (res.json && res.json?.success === true) {
                setInvGenerateState(invGenerateState + 1);
                setLoading(false);
                getSelectedInvoiceId(res.json.data.id);
                ToastMsg("success", res.json.message);
                getTaxInvoiceData(res.json.data.id);
                getCustomerNames();
                getInvoiceDetailsList("");
                setIsView(true);
                // setPrintButton(true);
                setHideCopy(true);
                // setHideBothSide({
                //   lg: "8",
                //   displayBlock: "",
                // });
                setSidebar(true);
              } else {
                setLoading(false);
                ToastMsg("error", "InvoiceNo Already Exist.");
                console.log(res);
                return;
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        }
      });
    }
  };

  const updateInvoice = (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    if (form?.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      ToastMsg("error", "Please fill all required fields");
    } else if (
      productDetails[0].productName === "" &&
      productDetails[0].discAmount !== 0
    ) {
      setErrMsg({ ...errMsg, products: "Please enter product" });
      ToastMsg("error", "Please Fill Product Details");
    } else {
      Swal.fire({
        title: "Do you want to update the invoice?",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Yes",
        denyButtonText: `Cancel`,
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          let filteredProductList = productDetails.filter((item, index) => {
            if (item.productName || item.hsnCode || item.cgst || item.sgst) {
              return item;
            }
          });
          var data = {
            ...invoiceFormDetails,
            purchInvDetails: filteredProductList,
          };
          PostCallWithAuthToken(
            ApiConfig.UPDATE_PURCHASE_INVOICE,
            JSON.stringify(data)
          )
            .then((res) => {
              if (res.json?.success === true) {
                setInvoiceAction("submitInvoice");
                setLoading(false);
                ToastMsg("success", res.json.message);
                setInvGenerateState(invGenerateState + 1);
                getCustomerNames();
                getInvoiceDetailsList("");
                // setIsView(true);
                // setPrintButton(true);
                // setHideCopy(true);
                getSelectedInvoiceId(res.json.data.id);
                getTaxInvoiceData(res.json.data.id);

                // setHideBothSide({
                //   lg: "8",
                //   displayBlock: "",
                // });
                setSidebar(true);
              } else {
                setLoading(false);
                ToastMsg("error", res.json.message);
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        }
      });
    }
  };

  // API CALL FUNCTION FOR INVIOCE NUMBER
  const getInvoiceNo = () => {
    const body = {
      type: "PurchaseService",
    };

    PostCallWithAuthToken(ApiConfig.GET_INVOICENO, JSON.stringify(body))
      .then((res) => {
        if (res.json && res.json?.success === true) {
          setInvoiceNo(res.json.data);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    setInvoiceFormDetails({
      ...invoiceFormDetails,
      invoiceNo: "",
      suppName: CopiedData.suppName,
      suppAddr: CopiedData.suppAddr,
      suppEmail: CopiedData.suppEmail,
      suppContact: CopiedData.suppContact,
      suppGstNo: CopiedData.suppGstNo,
      suppPanNo: CopiedData.suppPanNo,
      placeOfSupply: CopiedData.placeOfSupply,
      modeOfPay: CopiedData.modeOfPay,
      chequeNo: CopiedData.chequeNo,
      bankName: CopiedData.bankName,
    });
    if (CopiedData.purchInvDetails) {
      setProductDetails([
        ...CopiedData?.purchInvDetails,
        {
          hsnId: 0,
          gst: 0,
          gstAmount: 0,
          igst: 0,
          igstAmount: 0,
          sgst: 0,
          sgstAmount: 0,
          cgst: 0,
          cgstAmount: 0,
          discPer: 0,
          discAmount: 0,
          unitId: 15,
          productName: "",
          hsnCode: "",
          qty: 0,
          rate: 0,
        },
      ]);
    }
  }, [CopiedData]);

  useEffect(() => {
    let totalAmount = 0;
    let subTotal = 0;
    let igstAmount = 0;
    let cgstAmount = 0;
    let sgstAmount = 0;
    productDetails &&
      productDetails.length &&
      productDetails.map((item) => {
        igstAmount = igstAmount + item.igstAmount;
        cgstAmount = cgstAmount + item.cgstAmount;
        sgstAmount = sgstAmount + item.sgstAmount;
        subTotal = subTotal + item.discAmount;
        totalAmount = isStateSame
          ? totalAmount + item.discAmount + item.cgstAmount + item.sgstAmount
          : totalAmount + item.discAmount + item.igstAmount;
      });

    setInvoiceFormDetails({
      ...invoiceFormDetails,
      totalAmount: Math.floor(toFixedValue(totalAmount)),
      subTotal: toFixedValue(subTotal),
      igstAmount: toFixedValue(igstAmount),
      cgstAmount: toFixedValue(cgstAmount),
      sgstAmount: toFixedValue(sgstAmount),
      roundOff: appSettings.isRoundOff ? Number(roundedOff(totalAmount)) : 0,
    });
  }, [productDetails]);

  useEffect(() => {
    if (newInvoice || invGenerateState) {
      simpleGetCallWithToken(ApiConfig.GET_STATES)
        .then((res) => {
          if (res?.success) {
            simpleGetCallWithToken(ApiConfig.GET_PROFILE_DATA)
              .then((profileData) => {
                let supplierGstNumber = profileData.data.gstNo.substring(0, 2);
                let state =
                  res.data &&
                  res.data.filter(
                    (state, i) => state.code == supplierGstNumber
                  )[0];
                setInvoiceFormDetails({
                  ...invoiceFormDetails,
                  invoiceNo: "",
                  compName: profileData.data.companyName,
                  compAddr: profileData.data.address,
                  compEmail: profileData.data.email,
                  // compContact: "7745745522",
                  compContact: profileData.data.contactNo
                    ? profileData.data.contactNo
                    : "",
                  compGstNo: profileData.data.gstNo,
                  compPanNo: profileData.data.panNo,
                  placeOfSupply: state ? `${state.name}-${state.code}` : "",
                  suppPincode: profileData.data.pincode,
                  invoiceNo: "",
                  financialYearId: financialYearId,
                  invoiceDate: new Date().toISOString().toString(),
                  dueDate: new Date().toISOString().toString(),
                  subTotal: 0,
                  cgst: 0,
                  cgstAmount: 0,
                  sgst: 0,
                  sgstAmount: 0,
                  igst: 0,
                  igstAmount: 0,
                  suppName: "",
                  suppAddr: "",
                  suppState: "",
                  suppCountry: "",
                  suppEmail: "",
                  suppContact: "",
                  suppGstNo: "",
                  suppPanNo: "",
                  // placeOfSupply: `${state?.name}-${state?.code}`,
                  modeOfPay: "",
                  chequeNo: "",
                  bankName: "",
                  shipName: "",
                  shipAddr: "",
                  shipState: "",
                  shipCountry: "",
                  shipContact: "",
                  shipGstNo: "",
                  shipPanNo: "",
                  grossAmount: 0,
                  gstAmount: 0,
                  totalAmount: 0,
                  suppCity: "",
                });

                setValidated(false);

                if (newInvoice || invGenerateState) {
                  setProductDetails([
                    {
                      ...productDetails,
                      gst: 0,
                      gstAmount: 0,
                      igst: 0,
                      igstAmount: 0,
                      sgst: 0,
                      sgstAmount: 0,
                      cgst: 0,
                      cgstAmount: 0,
                      discPer: 0,
                      discAmount: 0,
                      unitId: 15,
                      productName: "",
                      hsnId: 0,
                      hsnCode: "",
                      qty: 0,
                      rate: 0,
                    },
                  ]);
                }
                setValidated(false);
              })
              .catch((err) => {
                console.log("catch error,", err);
              });
          }
        })
        .catch((error) => {
          console.log("catch error of states API,", error);
        });
    }
  }, [newInvoice, invGenerateState]);

  useEffect(() => {
    getStates();
    // getProfileData();
    getHsnCodes();
    getAccounts();
    getProducts();
    getCustomerNames();
    getUnits();
  }, []);

  const getStates = async () => {
    simpleGetCallWithToken(ApiConfig.GET_STATES)
      .then((res) => {
        if (res.success && res.success === true) {
          if (res.data !== null) setStates(res.data);
          setBackDropOpen(true);
          simpleGetCallWithToken(ApiConfig.GET_PROFILE_DATA).then(
            (profileData) => {
              setBackDropOpen(false);
              if (profileData.success === true) {
                let supplierGstNumber = profileData.data.gstNo.substring(0, 2);
                let state =
                  res.data &&
                  res.data.filter(
                    (state, i) => state.code == supplierGstNumber
                  )[0];

                if (invoiceAction === "edit") {
                  console.log("EditAction", invoiceEditData);
                  setInvoiceFormDetails({
                    ...invoiceFormDetails,
                    id: invoiceEditData.id ? invoiceEditData.id : "",
                    invoiceNo: invoiceEditData.invoiceNo
                      ? invoiceEditData.invoiceNo
                      : "",
                    invoiceDate: invoiceEditData.invoiceDate
                      ? invoiceEditData.invoiceDate
                      : "",
                    dueDate: invoiceEditData.dueDate
                      ? invoiceEditData.dueDate
                      : "",
                    suppName: invoiceEditData.suppName
                      ? invoiceEditData.suppName
                      : "",
                    suppAddr: invoiceEditData.suppAddr
                      ? invoiceEditData.suppAddr
                      : "",
                    suppEmail: invoiceEditData.suppEmail
                      ? invoiceEditData.suppEmail
                      : "",
                    suppContact: invoiceEditData.suppContact
                      ? invoiceEditData.suppContact
                      : "",
                    suppGstNo: invoiceEditData.suppGstNo
                      ? invoiceEditData.suppGstNo
                      : "",
                    suppPanNo: invoiceEditData.suppPanNo
                      ? invoiceEditData.suppPanNo
                      : "",
                    placeOfSupply: invoiceEditData.placeOfSupply
                      ? invoiceEditData.placeOfSupply
                      : "",
                    modeOfPay: invoiceEditData.modeOfPay
                      ? invoiceEditData.modeOfPay
                      : "",
                    chequeNo: invoiceEditData.chequeNo
                      ? invoiceEditData.chequeNo
                      : "",
                    bankName: invoiceEditData.bankName
                      ? invoiceEditData.bankName
                      : "",
                    shipName: invoiceEditData.shipName
                      ? invoiceEditData.shipName
                      : "",
                    shipAddr: invoiceEditData.shipAddr
                      ? invoiceEditData.shipAddr
                      : "",
                    shipEmail: invoiceEditData.shipEmail
                      ? invoiceEditData.shipEmail
                      : "",
                    shipContact: invoiceEditData.shipContact
                      ? invoiceEditData.shipContact
                      : "",
                    shipGstNo: invoiceEditData.shipGstNo
                      ? invoiceEditData.shipGstNo
                      : "",
                    shipPanNo: invoiceEditData.shipPanNo
                      ? invoiceEditData.shipPanNo
                      : "",
                    billCity: invoiceEditData?.suppCity
                      ? invoiceEditData.suppCity
                      : "",
                    billPincode: invoiceEditData?.suppPincode
                      ? invoiceEditData.suppPincode
                      : "",
                    compName: invoiceEditData?.compName,
                    compAddr: invoiceEditData?.compAddr,
                    compEmail: invoiceEditData?.compEmail,
                    compContact: invoiceEditData?.compContact
                      ? invoiceEditData?.compContact
                      : "",
                    compGstNo: invoiceEditData?.compGstNo,
                    compPanNo: invoiceEditData?.compPanNo,
                    suppPincode: invoiceEditData?.suppPincode
                      ? invoiceEditData?.suppPincode
                      : "",
                    suppCity: invoiceEditData?.suppCity
                      ? invoiceEditData?.suppCity
                      : "",
                  });

                  setProductDetails([
                    ...invoiceEditData?.purchInvDetails,
                    {
                      id: 0,
                      hsnId: 0,
                      gst: 0,
                      gstAmount: 0,
                      igst: 0,
                      igstAmount: 0,
                      sgst: 0,
                      sgstAmount: 0,
                      cgst: 0,
                      cgstAmount: 0,
                      discPer: 0,
                      discAmount: 0,
                      unitId: 15,
                      productName: "",
                      hsnCode: "",
                      qty: 0,
                      rate: 0,
                    },
                  ]);
                } else {
                  setInvoiceFormDetails({
                    ...invoiceFormDetails,
                    compName: profileData.data.companyName,
                    compAddr: profileData.data.address,
                    compEmail: profileData.data.email,
                    // compContact: "7745745522",
                    compContact: profileData.data.contactNo
                      ? profileData.data.contactNo
                      : "",
                    compGstNo: profileData.data.gstNo,
                    compPanNo: profileData.data.panNo,
                    placeOfSupply: state ? `${state.name}-${state.code}` : "",
                    suppPincode: profileData.data.pincode,
                  });
                }
              }
            }
          );
        } else {
          console.log(res);
          return;
        }
      })
      .catch((err) => console.log(err));
  };

  const getCustomerNames = async () => {
    const response = await simpleGetCallWithToken(ApiConfig.GET_CUSTOMER_NAMES);
    setNameList(response.data);
  };

  const getCustonerBillingData = async (billName) => {
    setBackDropOpen(true);
    let dataObj = {
      id: billName.id,
    };
    try {
      const res = await PostCallWithAuthToken(
        ApiConfig.GET_CUSTOMER_BILLING_DATA,
        JSON.stringify(dataObj)
      );
      if (res.json.success === true) {
        setBackDropOpen(false);
        let state =
          states &&
          states.filter(
            (state, i) => state.code == res.json.data.gstNo.substring(0, 2)
          )[0];
        setInvoiceFormDetails({
          ...invoiceFormDetails,
          suppName: res.json.data.customerName,
          suppAddr: res.json.data.billAddr,
          suppEmail: res.json.data.email,
          suppContact: res.json.data.contactNo,
          suppGstNo: res.json.data.gstNo,
          suppPanNo: res.json.data.panNo,
          placeOfSupply: state ? `${state.name}-${state.code}` : "",
          billPincode: res.json.data.pincode,
        });
      }
    } catch (error) {
      console.log("error,", error);
    } finally {
      setBackDropOpen(false);
    }
  };

  const addNewProductApiCall = () => {
    PostCallWithAuthToken(ApiConfig.ADD_NEW_PRODUCT, JSON.stringify(newProduct))
      .then((res) => {
        if (res.json.success) {
          setAddedNew(false);
          getProducts();
          ToastMsg("success", "Product added successfully");
        } else {
          return;
        }
      })
      .catch((err) => console.log(err));
  };

  const getHsnCodes = () => {
    simpleGetCallWithToken(ApiConfig.GET_HSNCODE)
      .then((res) => {
        setHsnCodes(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getAccounts = () => {
    simpleGetCallWithToken(ApiConfig.GET_ACCOUNT)
      .then((res) => {
        setAccount(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getProfileData = () => {
    setBackDropOpen(true);
    simpleGetCallWithToken(ApiConfig.GET_PROFILE_DATA)
      .then((res) => {
        setBackDropOpen(false);
        setInvoiceFormDetails({
          ...invoiceFormDetails,
          compName: res.data.companyName,
          compAddr: res.data.address,
          // compContact: "7745745522",
          compContact: res.data.contactNo ? res.data.contactNo : "",
          compGstNo: res.data.gstNo,
          compPanNo: res.data.panNo,
        });
      })
      .catch((err) => console.log(err));
  };

  // API CALL FUNCTION FOR PRODUCTS
  const getProducts = () => {
    simpleGetCallWithToken(ApiConfig.GET_PRODUCTS)
      .then((res) => {
        if (res.success && res.success === true) {
          setProducts(res.data);
        } else {
          return;
        }
      })
      .catch((err) => console.log(err));
  };

  const [units, setUnits] = useState([]);

  const getUnits = () => {
    simpleGetCallWithToken(ApiConfig.GET_UNITS)
      .then((res) => {
        if (res.success === true) {
          setUnits(res.data);
        }
      })
      .catch((err) => console.log(err));
  };

  const addNewRow = (e) => {
    e.preventDefault();
    let data = {
      gst: 0,
      gstAmount: 0,
      igst: 0,
      igstAmount: 0,
      sgst: 0,
      sgstAmount: 0,
      cgst: 0,
      cgstAmount: 0,
      discPer: 0,
      discAmount: 0,
      unitId: 15,
      productName: "",
      hsnId: 0,
      hsnCode: "",
      qty: 0,
      rate: 0,
    };

    let newdata = [...productDetails, data];
    setProductDetails(newdata);
  };

  const goodsHandleChange = (name, event) => {
    setInvoiceFormDetails({
      ...invoiceFormDetails,
      [name]: event.target.value,
    });
  };

  const getSelectedInvoiceId = (selectedId) => {
    reciveInvoiceId(selectedId);
  };

  const DeleteHandler = (index) => {
    let filterArray = [];
    productDetails.filter((item, innerIndex) => {
      if (index !== innerIndex) {
        filterArray.push(item);
      }
    });
    setProductDetails(filterArray);
  };

  const getDetailsByGstNumber = (gstNumber, gstNumberType) => {
    if (gstNumber.length === 15) {
      setBackDropOpen(true);
      simpleGetCallWithToken(
        ApiConfig.GET_GSTIN_DETAILS + `/${gstNumber.toUpperCase()}`
      )
        .then((res) => {
          setBackDropOpen(false);
          let gstDetail = res.data.lstAppSCommonSearchTPResponse[0];
          let address =
            gstDetail.pradr.addr.flno +
            "," +
            " " +
            gstDetail.pradr.addr.bno +
            "," +
            " " +
            gstDetail.pradr.addr.bnm +
            "," +
            " " +
            gstDetail.pradr.addr.st +
            "," +
            " " +
            gstDetail.pradr.addr.loc +
            "," +
            " " +
            gstDetail.pradr.addr.stcd;

          if (gstNumberType === "shipGstNumber") {
            setInvoiceFormDetails({
              ...invoiceFormDetails,
              shipName: gstDetail.tradeNam,
              shipAddr: address,
              shipGstNo: gstDetail.gstin,
              shipPanNo: gstDetail.gstin.substring(2, 12),
              shipPincode: gstDetail.pradr.addr.pncd,
            });
          } else {
            let state =
              states &&
              states.filter(
                (state, i) => state.code == gstDetail.gstin.substring(0, 2)
              )[0];
            setInvoiceFormDetails({
              ...invoiceFormDetails,
              suppName: gstDetail.tradeNam,
              suppAddr: address,
              suppGstNo: gstDetail.gstin,
              suppPanNo: gstDetail.gstin.substring(2, 12),
              //placeOfSupply: `${state.name}-${state.code}`,
              suppPincode: gstDetail.pradr.addr.pncd,
              suppCity: gstDetail.pradr.addr.loc,
            });
          }
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <main id="purchase-edit-invoice">
      {/* <BackDropLoader
        backDropOpen={backDropOpen}
        setBackDropOpen={setBackDropOpen}
      /> */}
      <Form
        noValidate
        validated={validated}
        onSubmit={invoiceAction === "edit" ? updateInvoice : savePurchaseForm}
      >
        <div id="main-default-edit-form">
          <div className="main-invoice-card">
            <div className="invoice-inner-main">
              <div className="invoice-expense-top">
                <div className="purchase-inv">
                  <div className="pur-small-screen">
                    <label htmlFor="" className="expense-label-text">
                      Invoice No.
                    </label>
                    {/* <label
                      htmlFor=""
                      className="ms-2 expense-label-text-grey linnetext"
                    >
                      {invoiceNo}
                    </label> */}
                    <div
                      className="input-with-pencile"
                      style={{ marginLeft: "10px", width: "145px" }}
                    >
                      <input
                        id="invoiceNo"
                        name="invoiceNo"
                        type="text"
                        style={{ marginTop: "8px" }}
                        className="form-control mb-1 invoice-number-style"
                        value={invoiceFormDetails.invoiceNo}
                        placeholder="Invoice Number"
                        // required={invoiceFormDetails.invoiceNo === '' ? true : false}
                        required
                        onChange={(e) => {
                          setInvoiceFormDetails({
                            ...invoiceFormDetails,
                            invoiceNo: e.target.value.toUpperCase(),
                          });
                          setInvoiceNo(e.target.value.toUpperCase());
                        }}
                      />
                      {/* <img className="pen" src={ic_blue_pen} alt="" /> */}
                      <div className="invalid-feedback font-11">
                        Please Enter Invoice Number
                      </div>
                    </div>
                  </div>

                  <div className=" pur-small-screen">
                    <label
                      htmlFor=""
                      className="expense-label-text daterespomsive"
                    >
                      Date:
                    </label>
                    <DatePicker
                      selected={
                        invoiceFormDetails.invoiceDate
                          ? new Date(invoiceFormDetails.invoiceDate)
                          : new Date()
                      }
                      value={
                        invoiceFormDetails.invoiceDate
                          ? displayDateFormat(
                            appSettings.dateFormat,
                            invoiceFormDetails.invoiceDate
                          )
                          : ""
                      }
                      onChange={(date) => {
                        // setInvoiceDate(date);
                        setInvoiceFormDetails({
                          ...invoiceFormDetails,
                          invoiceDate: new Date(date).toISOString().toString(),
                        });
                      }}
                      showYearDropdown
                      // dateFormat="dd/MM/yyyy"
                      placeholderText="Choose a date"
                      className="form-control cust-expense-inp ms-2"
                    />
                    {Dark === "lightMode" ? (
                      <img src={calendersvg} className="calendarI" alt="" />
                    ) : (
                      <img
                        src={calendersvg_dark}
                        className="calendarI"
                        alt=""
                      />
                    )}{" "}
                    {/* <img
                      src={ic_blue_pen}
                      className="b-pen-expense ms-3 modalmarginleft05"
                      alt=""
                    /> */}
                  </div>

                  <div className=" pur-small-screen">
                    <label
                      htmlFor=""
                      className="expense-label-text daterespomsive"
                    >
                      Due Date:
                    </label>
                    <DatePicker
                      selected={
                        invoiceFormDetails.dueDate
                          ? new Date(invoiceFormDetails.dueDate)
                          : new Date()
                      }
                      value={
                        invoiceFormDetails.dueDate
                          ? displayDateFormat(
                            appSettings.dateFormat,
                            invoiceFormDetails.dueDate
                          )
                          : ""
                      }
                      onChange={(date) => {
                        setInvoiceFormDetails({
                          ...invoiceFormDetails,
                          dueDate: new Date(date).toISOString().toString(),
                        });
                      }}
                      showYearDropdown
                      // dateFormat="dd/MM/yyyy"
                      // minDate={new Date(invoiceDate)}
                      placeholderText="Choose a date"
                      className="form-control cust-expense-inp ms-2"
                    />
                    {Dark === "lightMode" ? (
                      <img src={calendersvg} className="calendarI" alt="" />
                    ) : (
                      <img
                        src={calendersvg_dark}
                        className="calendarI"
                        alt=""
                      />
                    )}{" "}
                    {/* <img
                      src={ic_blue_pen}
                      className="b-pen-expense ms-2"
                      alt=""
                    /> */}
                  </div>
                </div>
              </div>
              <div className="borderTopBottom"></div>
              {/* ========================================================== */}
              <div className="name-details-main">
                <div className="name-details-inner ">
                  {/* supplier details */}
                  <div className="left">
                    <div className="left-input-info">
                      <input
                        type="text"
                        name="compName"
                        className="form-control mb-1"
                        id="name"
                        value={invoiceFormDetails.compName}
                        style={{ border: "none", width: "260px" }}
                        disabled
                      />
                      <textarea
                        name="compAddr"
                        id="text-area"
                        cols="30"
                        rows="10"
                        className="form-control mb-1"
                        placeholder="Address"
                        value={invoiceFormDetails.compAddr}
                        style={{ border: "none", width: "auto" }}
                        disabled
                      ></textarea>

                      <div className="contact" style={{ width: "280px" }}>
                        <label htmlFor="">Email Id </label>
                        <input
                          type="email"
                          name="compEmail"
                          className="form-control mb-1"
                          value={invoiceFormDetails.compEmail}
                          style={{ border: "none", width: "206px" }}
                          disabled
                        />
                      </div>

                      <div className="contact">
                        <label htmlFor="">Contact No. </label>
                        <input
                          type="text"
                          name="compContact"
                          className="form-control mb-1"
                          maxLength={10}
                          value={invoiceFormDetails.compContact}
                          style={{ border: "none" }}
                          disabled
                        />
                      </div>
                      {appSettings && appSettings.isGSTApplicable && (

                        <div className="contact mb-1">
                          <label htmlFor="">
                            GST No. <br /> <span>(Optional)</span>{" "}
                          </label>
                          <input
                            type="text"
                            name="compGstNo"
                            className="form-control"
                            placeholder=""
                            value={invoiceFormDetails.compGstNo}
                            style={{ border: "none" }}
                            disabled
                          />
                        </div>)}
                      <div className="contact mb-1">
                        <label htmlFor="">PAN No.</label>
                        <input
                          type="text"
                          name="compPanNo"
                          className="form-control"
                          placeholder=""
                          value={invoiceFormDetails.compPanNo}
                          style={{ border: "none" }}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="right">
                    <div className="place-text-right">
                      <div className="mb-4 marginttop4">
                        <label htmlFor="" className="key">
                          Place of Supply :
                        </label>
                        <div className="input-with-pencile">
                          <select
                            id="placeOfSupply"
                            className="form-select"
                            aria-label="Default select example"
                            name="placeOfSupply"
                            required
                            disabled={
                              invoiceFormDetails.suppGstNo ? true : false
                            }
                            value={invoiceFormDetails.placeOfSupply}
                            onChange={(e) => {
                              goodsHandleChange("placeOfSupply", e);
                            }}
                          >
                            <option value="">Open this select menu</option>
                            {states &&
                              states.map((state) => (
                                <option
                                  value={`${state.name}-${state.code}`}
                                >{`${state.name}-${state.code}`}</option>
                              ))}
                          </select>
                          {/* <img className="pen" src={ic_blue_pen} alt="" /> */}
                          <div className="invalid-feedback font-11">
                            Please Select Place Of Supply
                          </div>
                        </div>
                      </div>
                      <div className="marginttop4">
                        <label htmlFor="" className="key">
                          Mode of Payment:
                        </label>
                        <div className="input-with-pencile mb-1">
                          <select
                            id="modeOfPay"
                            className="form-select"
                            aria-label="Default select example"
                            name="modeOfPay"
                            required
                            value={invoiceFormDetails.modeOfPay}
                            onChange={(e) => {
                              goodsHandleChange("modeOfPay", e);
                            }}
                          >
                            <option value="">Open this select menu</option>
                            <option value="Cash">Cash</option>
                            <option value="Credit">Credit</option>
                            <option value="Online">Online</option>
                            <option value="Cheque">Cheque</option>
                          </select>
                          {/* <img className="pen" src={ic_blue_pen} alt="" /> */}
                          <div className="invalid-feedback font-11">
                            Please Select Mode Of Payment
                          </div>
                        </div>
                      </div>
                      <div className="input-with-pencile mb-1">
                        {invoiceFormDetails.modeOfPay === "Cheque" ? (
                          <>
                            <input
                              id="chequeNo"
                              type="text"
                              className="form-control"
                              placeholder="Cheque No. XXX06542"
                              name="chequeNo"
                              required={
                                invoiceFormDetails.modeOfPay === "Cheque"
                                  ? true
                                  : false
                              }
                              value={invoiceFormDetails.chequeNo}
                              onChange={(e) => {
                                goodsHandleChange("chequeNo", e);
                              }}
                            />

                            {/* <img className="pen" src={ic_blue_pen} alt="" /> */}
                            <div className="invalid-feedback font-11">
                              Please provide Cheque No.
                            </div>
                          </>
                        ) : null}
                      </div>

                      <div className="input-with-pencile mb-1">
                        {invoiceFormDetails.modeOfPay === "Cheque" ? (
                          <>
                            <input
                              id="bankName"
                              type="text"
                              name="bankName"
                              className="form-control"
                              placeholder="Name of Bank"
                              required={
                                invoiceFormDetails.modeOfPay === "Cheque"
                                  ? true
                                  : false
                              }
                              value={invoiceFormDetails.bankName}
                              onChange={(e) => {
                                goodsHandleChange("bankName", e);
                              }}
                            />

                            {/* <img className="pen" src={ic_blue_pen} alt="" /> */}
                            <div className="invalid-feedback font-11">
                              Please provide Bank Name
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="name-details-main" id="info">
                <div className="name-details-inner">
                  <div className=" left " id="left">
                    <div className="name">
                      <label htmlFor="" id="small-heading">
                        Party Name/Supplier Name
                      </label>
                    </div>
                    <div className="left-input-info">
                      <div className="input-with-pencile">
                        <input
                          id="suppName"
                          list="customerNames"
                          type="text"
                          className="form-control mb-1 me-2"
                          placeholder="Name"
                          name="suppName"
                          required
                          value={invoiceFormDetails.suppName}
                          onChange={(e) => {
                            goodsHandleChange("suppName", e);
                            let billNames = nameList.filter((item, index) => {
                              if (item.customerName === e.target.value) {
                                return item;
                              }
                            })[0];
                            billNames && getCustonerBillingData(billNames);
                          }}
                        />{" "}
                        <datalist
                          id="customerNames"
                          className="datalist-product"
                        >
                          {nameList &&
                            nameList.map((item) => {
                              return (
                                <>
                                  <option>{item.customerName}</option>
                                </>
                              );
                            })}
                        </datalist>
                        {/* <img className="pen" src={ic_blue_pen} alt="" /> */}
                        <div className="invalid-feedback font-11">
                          Please provide Name
                        </div>
                      </div>

                      <div className="input-with-pencile">
                        <textarea
                          name="suppAddr"
                          id="suppAddr"
                          cols="30"
                          rows="10"
                          required
                          className="form-control mb-1  me-2"
                          placeholder="Address"
                          value={invoiceFormDetails.suppAddr}
                          onChange={(e) => {
                            goodsHandleChange("suppAddr", e);
                          }}
                          style={{ height: "60px", resize: "none" }}
                        />

                        {/* <img className="pen" src={ic_blue_pen} alt="" /> */}
                        <div className="invalid-feedback font-11">
                          Please provide Address
                        </div>
                      </div>
                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">City</label>
                        <div className="">
                          <input
                            id="suppCity"
                            type="text"
                            name="suppCity"
                            className="form-control mb-1 me-2"
                            value={invoiceFormDetails.suppCity}
                            onChange={(e) => {
                              goodsHandleChange("suppCity", e);
                            }}
                          />
                        </div>
                      </div>
                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">Pin</label>
                        <div className="">
                          <input
                            id="suppPincode"
                            type="text"
                            name="suppPincode"
                            className="form-control mb-1 me-2"
                            value={invoiceFormDetails.suppPincode}
                            onChange={(e) => {
                              goodsHandleChange("suppPincode", e);
                            }}
                          />
                        </div>
                      </div>
                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">Email Id </label>
                        <div className="">
                          <input
                            type="email"
                            name="suppEmail"
                            className="form-control mb-1 me-2"
                            required
                            maxLength={20}
                            value={invoiceFormDetails.suppEmail}
                            onChange={(e) => {
                              goodsHandleChange("suppEmail", e);
                            }}
                          />
                        </div>
                      </div>

                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">Contact No. </label>
                        <div className="">
                          <input
                            type="text"
                            name="suppContact"
                            className="form-control mb-1 me-2"
                            maxLength={10}
                            required
                            value={invoiceFormDetails.suppContact}
                            onChange={(e) => {
                              const regex = /^[0-9 +\b]+$/;
                              if (
                                e.target.value == "" ||
                                regex.test(e.target.value)
                              ) {
                                goodsHandleChange("suppContact", e);
                              }
                            }}
                          />
                        </div>
                      </div>
                      {appSettings && appSettings.isGSTApplicable && (

                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">
                            GST No. <br />{" "}
                          </label>
                          <div className="">
                            {" "}
                            <input
                              type="text"
                              name="suppGstNo"
                              className="form-control me-2"
                              placeholder="XX-XXXXXXXXXX"
                              value={invoiceFormDetails.suppGstNo}
                              onChange={(e) => {
                                handleInvoiceSearch(e);
                                setInvoiceFormDetails({
                                  ...invoiceFormDetails,
                                  suppGstNo: e.target.value.toUpperCase(),
                                });
                                getDetailsByGstNumber(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      )}

                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">PAN No.</label>
                        <div className="">
                          <input
                            type="text"
                            name="suppPanNo"
                            className="form-control me-2"
                            placeholder="XXXXXXXXXX"
                            value={invoiceFormDetails.suppPanNo}
                            onChange={(e) => {
                              goodsHandleChange("suppPanNo", e);
                            }}
                          />
                        </div>
                      </div>

                      {/* {invoiceFormDetails.suppGstNo === "" && (
                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">State</label>
                          <div className="input-with-pencile">
                            <select
                            style={{width : "150px", marginRight : "8px"}}
                              // id="placeOfSupply"
                              className="form-select"
                              aria-label="Default select example"
                              name="suppState"
                              value={invoiceFormDetails.suppState}
                              onChange={(e) => {
                                setInvoiceFormDetails({
                                  ...invoiceFormDetails,
                                  suppState : e.target.value,
                                  placeOfSupply: e.target.value,
                                });
                              }}
                            >
                              <option value="">Select state</option>
                              {states &&
                                states.map((state) => (
                                  <option
                                    value={`${state.name}-${state.code}`}
                                  >{`${state.name}-${state.code}`}</option>
                                ))}
                            </select>
                           
                          </div>
                        </div>
                      )} */}
                    </div>
                  </div>

                  {/* Ship to details */}

                  {/* <div className=" left " id="left">
                    <div className="name marginttop4">
                      <label htmlFor="" id="small-heading">
                        Ship To,{" "}
                        <span className="purchase-diff">(if required)</span>
                      </label>
                    </div>
                    <div className="left-input-info">
                      <div className="input-with-pencile">
                        <input
                          id="shipName"
                          type="text"
                          name="shipName"
                          className="form-control mb-1 me-2"
                          placeholder="Name"
                          value={invoiceFormDetails.shipName}
                          onChange={(e) => {
                            goodsHandleChange("shipName", e);
                          }}
                        />{" "}
                        <img className="pen" src={ic_blue_pen} alt="" />
                      </div>

                      <div className="input-with-pencile">
                        <textarea
                          id="shipName"
                          cols="30"
                          rows="10"
                          className="form-control mb-1  me-2"
                          placeholder="Address"
                          name="shipAddr"
                          value={invoiceFormDetails.shipAddr}
                          onChange={(e) => {
                            goodsHandleChange("shipAddr", e);
                          }}
                          style={{ height: "60px", resize: "none" }}
                        />

                        <img className="pen" src={ic_blue_pen} alt="" />
                      </div>

                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">Contact No. </label>
                        <div className="">
                          <input
                            id="shipContact"
                            type="text"
                            className="form-control mb-1 me-2"
                            name="shipContact"
                            value={invoiceFormDetails.shipContact}
                            onChange={(e) => {
                              const regex = /^[0-9\b]+$/;
                              if (
                                e.target.value == "" ||
                                regex.test(e.target.value)
                              ) {
                                goodsHandleChange("shipContact", e);
                              }
                            }}
                          />

                          <img className="pen_1" src={ic_blue_pen} alt="" />
                        </div>
                      </div>

                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">
                          GST No. <br />{" "}
                        </label>
                        <div className="">
                          {" "}
                          <input
                            id="shipGstNo"
                            type="text"
                            className="form-control me-2"
                            placeholder="XX-XXXXXXXXXX"
                            name="shipGstNo"
                            value={invoiceFormDetails.shipGstNo}
                            onChange={(e) => {
                              handleInvoiceSearch(e);
                              getDetailsByGstNumber(
                                e.target.value,
                                "shipGstNumber"
                              );
                              goodsHandleChange("shipGstNo", e);
                            }}
                          />
                          <img className="pen_1" src={ic_blue_pen} alt="" />
                        </div>
                      </div>

                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">PAN No.</label>
                        <div className="">
                          <input
                            id="shipPanNo"
                            type="text"
                            className="form-control me-2"
                            placeholder="XXXXXXXXXX"
                            name="shipPanNo"
                            value={invoiceFormDetails.shipPanNo}
                            onChange={(e) => {
                              goodsHandleChange("shipPanNo", e);
                            }}
                          />

                          <img className="pen_1" src={ic_blue_pen} alt="" />
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="detail-table-main">
                <ProductTable
                  isStateSame={isStateSame}
                  productDetails={productDetails}
                  setProductDetails={setProductDetails}
                  units={units}
                  addNewRow={addNewRow}
                  setBackDropOpen={setBackDropOpen}
                  errMsg={errMsg}
                  permissions={permissions}
                  setErrMsg={setErrMsg}
                  DeleteHandler={DeleteHandler}
                  currentRoute={currentRoute}
                  appSettings={appSettings}
                />
              </div>
              <div className="sub-total-section">
                <div className="left">
                  <div className="text-sub">
                    <label htmlFor="">Sub Total</label>
                  </div>
                  {appSettings && appSettings.isGSTApplicable &&
                    (isStateSame) ? (
                    <>
                      <div className="text-sub">
                        <label htmlFor="">CGST</label>
                      </div>
                      <div className="text-sub">
                        <label htmlFor="">SGST</label>
                      </div>
                    </>
                  ) : (
                    <>
                      {appSettings && appSettings.isGSTApplicable && (
                        <div className="text-sub">
                          <label htmlFor="">IGST</label>
                        </div>)}
                    </>
                  )}
                  {appSettings && appSettings.isRoundOff && (
                    <div className="text-sub">
                      <label htmlFor="">Round off</label>
                    </div>
                  )}
                </div>
                <div className="right">
                  <div className="sub-total">
                    <label htmlFor="">
                      ₹
                      {invoiceFormDetails?.subTotal
                        ? parseFloat(invoiceFormDetails?.subTotal).toFixed(2)
                        : 0}
                    </label>
                  </div>
                  {appSettings && appSettings.isGSTApplicable &&
                    (isStateSame) ? (
                    <>
                      <div className="sub-total">
                        <label htmlFor="">
                          ₹
                          {invoiceFormDetails.cgstAmount
                            ? parseFloat(invoiceFormDetails.cgstAmount).toFixed(
                              2
                            )
                            : 0}
                        </label>
                      </div>
                      <div className="sub-total">
                        <label htmlFor="">
                          ₹
                          {invoiceFormDetails.sgstAmount
                            ? parseFloat(invoiceFormDetails.sgstAmount).toFixed(
                              2
                            )
                            : 0}
                        </label>
                      </div>
                    </>
                  ) : (
                    <>
                      {appSettings && appSettings.isGSTApplicable && (
                        <div className="sub-total">
                          <label htmlFor="">
                            ₹
                            {invoiceFormDetails.igstAmount
                              ? parseFloat(invoiceFormDetails.igstAmount).toFixed(2)
                              : 0}
                          </label>
                        </div>)}
                    </>
                  )}
                  {appSettings && appSettings.isRoundOff && (
                    <div className="sub-total">
                      <label htmlFor="">
                        {invoiceFormDetails.roundOff
                          ? invoiceFormDetails.roundOff
                          : 0}
                      </label>
                    </div>
                  )}
                </div>
              </div>
              <div className="mainsub-total"></div>
              <div className="total-amt-main">
                <div className="sub-total-section" id="sub-total-section">
                  <div className="left">
                    <div className="text-sub">
                      <label htmlFor="">Total Amount</label>
                    </div>
                  </div>
                  <div className="right">
                    <div className="sub-total">
                      <label htmlFor="">
                        ₹
                        {invoiceFormDetails.totalAmount
                          ? commaNumber(
                            Math.floor(
                              invoiceFormDetails.totalAmount
                            ).toFixed(2)
                          )
                          : 0}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="in-word">
                  <label htmlFor="">{amountInWords}</label>
                </div>
              </div>
              {/* <div className="line-total"></div> */}
            </div>
            <div className="text-end">
              <button
                disabled={loading ? true : false}
                className="submit-btn-blue"
                type="submit"
                style={{ width: "98px", height: "29px", textAlign: "center" }}
                onClick={getFocus}
              >
                {loading ? (
                  <div
                    className="spinner-border text-secondar"
                    role="status"
                    style={{ width: "1rem", height: "1rem", margin: "-2 -2" }}
                  >
                    <span className="sr-only mt-3"></span>
                  </div>
                ) : invoiceAction === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </div>
        </div>
      </Form>

      {/* Modal Of Add new row*/}
      <Modal
        show={addedNew}
        size="lg"
        onHide={() => setAddedNew(false)}
        centered
        className="purchase-add-row-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            New Product
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="add-row-content-modal">
              {/* Two inputs */}
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Product Code
                    </label>
                    <input
                      type="text"
                      className="form-control input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          productCode: e.target.value,
                        });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a product code.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Product Name
                    </label>
                    <input
                      type="text"
                      className="form-control input-add-row "
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          productName: e.target.value,
                        });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a product name.
                    </Form.Control.Feedback>
                  </div>
                </div>
              </div>

              {/* Three Columns */}
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Unit Price
                    </label>
                    <input
                      type="text"
                      className="form-control input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          rate: Number(e.target.value),
                        });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide Unit Price.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Account
                    </label>
                    <select
                      className="form-select input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          ledgerAccId: Number(e.target.value),
                        });
                      }}
                    >
                      <option value="">Please select</option>
                      {account &&
                        account.map((item) => (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                    <Form.Control.Feedback type="invalid">
                      Please provide an Account.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      HSN Code
                    </label>
                    <select
                      className="form-select input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          hsnId: Number(e.target.value),
                          hsnCode: hsnCodes.filter((item) => {
                            return item.id === Number(e.target.value)
                              ? item.taxRate
                              : 0;
                          })[0].hsnCode,
                          taxRate: hsnCodes.filter((item) => {
                            return item.id === Number(e.target.value)
                              ? item.taxRate
                              : 0;
                          })[0].taxRate,
                        });
                      }}
                    >
                      <option value="">Please select</option>
                      {hsnCodes &&
                        hsnCodes.map((code) => (
                          <option value={code.id} key={code.id}>
                            {code.hsnCode}
                          </option>
                        ))}
                    </select>
                    <Form.Control.Feedback type="invalid">
                      Please provide HSN Code.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Tax Rate
                    </label>
                    <input
                      type="text"
                      className="form-control input-add-row"
                      disabled
                      required
                      value={newProduct.taxRate}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide Tax Rate
                    </Form.Control.Feedback>
                  </div>
                </div>
              </div>

              {/* Radio buttons */}
              {/* <div className="d-flex  justify-content-start flex-wrap">
                <div className="form-check mx-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={newProduct.isPurchase}
                    id="flexCheckDefault"
                    onChange={(e) => {
                      setNewProduct({
                        ...newProduct,
                        isPurchase: e.target.checked,
                        isSell: !e.target.checked,
                      });
                      setErrMsg({ ...errMsg, selectField: true });
                    }}
                  />
                  <label className="label-add-row" for="flexCheckDefault">
                    I Purchase This Item
                  </label>
                </div>

                <div className="form-check mx-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={newProduct.isSell}
                    id="flexCheckDefault2"
                    onChange={(e) => {
                      setNewProduct({
                        ...newProduct,
                        isSell: e.target.checked,
                        isPurchase: !e.target.checked,
                      });
                      setErrMsg({ ...errMsg, selectField: true });
                    }}
                  />
                  <label className="label-add-row" for="flexCheckDefault2">
                    I Sell This Item
                  </label>
                </div>
              </div> */}
            </div>
            <Modal.Footer>
              <Link
                to="#"
                className="cancelbtn text-center"
                onClick={() => setAddedNew(false)}
              >
                Cancel
              </Link>
              <button className="savebtn text-center" type="submit">
                Save
              </button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </main>
  );
};

export default PurchaseServiceForm;
